/* ============================================================
   REVELATIONS — Magazine Motion
   Subtle parallax on large image tiles only.
   Respects prefers-reduced-motion.
   No fade-in — content is always fully visible.
============================================================ */

(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var parallaxTargets = document.querySelectorAll(
    '.mag-tile-image[data-ratio="cinema"] img, ' +
    '.mag-spread [data-slot="a"] .mag-tile-image img, ' +
    '.mag-cover__img, ' +
    '.mag-interlude__img'
  );
  if (!parallaxTargets.length) return;

  var ticking = false;

  function updateParallax() {
    parallaxTargets.forEach(function (img) {
      var rect = img.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var viewportCenter = window.innerHeight / 2;
      var imgCenter = rect.top + rect.height / 2;
      var distance = imgCenter - viewportCenter;
      var maxOffset = 24;
      var offset = -(distance / window.innerHeight) * maxOffset;
      img.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateParallax, { passive: true });
  updateParallax();
})();
